import angular from 'angular';
import CheckboxGroupComponent from './checkbox-group.component';

const checkboxGroup = angular
	.module('checkboxGroup', [])
	.component('checkboxGroup', CheckboxGroupComponent)
	.name;

export default checkboxGroup;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/checkbox-group/checkbox-group.module.js